<template>
    <div class="mt-5 old-request-type-bloc">
        <h2 class="ml-5 mb-5">{{ title }} ({{ requests.length }})</h2>

        <v-card v-for="request in requests" class="mb-3">
            <v-card-text>
                <div class="d-md-flex justify-content-between">
                    <div class="d-flex">
                        <div v-if="request.type === 'CADH'"
                            class="mr-3 mt-auto mb-auto">
                            <v-img height="60px" width="60px" style="border-radius: 250px" src="/images/handshake.png">
                            </v-img>
                        </div>
                        <div v-else-if="request.providerData !== undefined && request.providerData.medias.length"
                             class="mr-3 mt-auto mb-auto">
                            <v-img height="60px"
                                   width="60px"
                                   style="border-radius: 250px"
                                   :src="(request.providerData.medias[0].thumbnail_url !== null) ?
                                          request.providerData.medias[0].thumbnail_url :
                                          request.providerData.medias[0].url">
                            </v-img>
                        </div>
                        <div v-else style="width: 72px" class="pro-top-menu">
                            <v-img height="60px" width="60px" style="border-radius: 250px" src="/images/building.svg">
                            </v-img>
                        </div>

                        <div v-if="request.providerData !== undefined">
                            <div class="d-md-flex ml-2 mb-2">
                                <div class="category-chip text-center mr-3">{{ request.providerData.category.label }}
                                </div>
                                <h4 style="font-size: 21px">{{ request.providerData.name }}</h4>
                            </div>

                            <div>{{ generateAddress(request.providerData.localisation) }}</div>
                        </div>
                        <div v-else>
                            <h4 style="font-size: 21px">{{ request.name }}</h4>
                        </div>
                    </div>

                    <div class="mt-auto mb-auto">
                        <b>Réponse le {{ formatDate(request.answeredAt, false) }}</b>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: "OldRequestBloc",
    props: ['title', 'requests'],
    methods: {
        generateAddress(localisation) {
            let address = ''

            if (localisation !== null) {
                if (localisation.address !== null) {
                    address += localisation.address
                }

                if (localisation.postal_code !== null) {
                    if (address !== '') {
                        address += ', '
                    }

                    address += localisation.postal_code
                }

                if (localisation.commune !== null) {
                    if (address !== '') {
                        address += ' '
                    }

                    address += localisation.commune.name
                }
            }

            return address
        },
        openForm(request) {
            window.open(request.url, '_self')
        }
    }
}
</script>